import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var EqualNot = createReactComponent("EqualNot", ["svg", defaultAttributes, [["line", {
  x1: "5",
  y1: "9",
  x2: "19",
  y2: "9",
  key: "wuwez1"
}], ["line", {
  x1: "5",
  y1: "15",
  x2: "19",
  y2: "15",
  key: "h3flfx"
}], ["line", {
  x1: "19",
  y1: "5",
  x2: "5",
  y2: "19",
  key: "18lstb"
}]]]);
export default EqualNot;